module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "author"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "font-size": "120%",
      "margin-top": "15%"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ESS")]), _vm._v(" S"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MITH")])]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }, [_vm._v("was raised in a large family of Scottish travellers. She is married with three children and six grandchildren. As a traditional storyteller, she is in great demand for live\n  performances throughout Scotland. This is the first book in her autobiographical trilogy, which continues with "), _c('i', [_vm._v("Tales from the Tent")]), _vm._v(" and concludes with "), _c('i', [_vm._v("Tears for a Tinker.")]), _vm._v(" She has also\n  written a novel, "), _c('i', [_vm._v("Bruar’s Rest")]), _vm._v(", and a collection of stories for young readers, "), _c('i', [_vm._v("Sookin’ Berries.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90739bcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/002_author.vue
// module id = 60
// module chunks = 0